import Image from "next/image";
import styles from "./Possibilities.module.css";
import PolygonBg from "@/assets/img/solutions/possibility_polygonoutline_group.svg";
import { Tag } from "antd";

const PossibiliyCard = ({ data }) => {
  return (
    <div className={styles.card}>
      <Image
        src={PolygonBg}
        alt="Polygon group bg"
        width="auto"
        height="auto"
        className="absolute top-0 right-0 -z-0"
      />
      <div className="p-[42px] h-full flex justify-center items-center capitalize">
        <div className="flex flex-col gap-8">
          <h4 className="text-base/[120%] md:text-2xl/normal font-bold">
            {data && data.title}
          </h4>
          <p className="text-xs/normal md:text-base/normal">
            {data && data.content}
          </p>
          <Tag
            className="text-xs/normal md:text-base/normal font-bold cursor-pointer capitalize"
            style={{
              color: "#E93249",
              borderRadius: "20px",
              padding: "4px 12px",
              backgroundColor: "unset",
              border: "1px solid #E93249",
              textAlign: "center",
            }}
          >
            {data && data.tag}
          </Tag>
        </div>
      </div>
    </div>
  );
};

export default PossibiliyCard;
